import { Injectable } from '@angular/core';
import { TAllCustomFields } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { CustomFieldsService } from 'src/app/project/modules/custom-fields/custom-fields.service';
import { TWorkspace } from 'src/app/project/modules/workspace/workspace.model';
import { removeDuplicates } from '../site-filter-dropdown-utils/remove-duplicates';

@Injectable({
  providedIn: 'root',
})
export class SiteFilterDropdownService {
  private focused: boolean;

  constructor(private customFieldsService: CustomFieldsService) {}

  getCustomFields(workspace: TWorkspace): TAllCustomFields {
    if (workspace) {
      return this.customFieldsService.getCustomFields();
    } else {
      return this.removeDuplicates();
    }
  }

  removeDuplicates(): TAllCustomFields {
    const customFields = this.customFieldsService.getCustomFields();

    return removeDuplicates(customFields);
  }

  setFocused(focused: boolean): void {
    this.focused = focused;
  }

  isFocused(): boolean {
    return this.focused;
  }
}
